import {gql} from '@apollo/client'
import {useMutation} from 'hooks/graphql'

export const REQUEST_PROCEDURE_INPUT = gql`
  mutation requestProcedureInput($input: RequestProcedureInputInput!) {
    requestProcedureInput(input: $input) {
      procedureStatus {
        id
      }
    }
  }
`

export interface Variables {
  input: {
    employeeId: string
    procedureType: string
    message?: string
  }
}

export const useRequestProcedureInput = () => useMutation<unknown, Variables>(REQUEST_PROCEDURE_INPUT)
